import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/s/grip/sources'))),
    class: "c-button-sources"
  }, _toDisplayString(_ctx.$t('SOURCES_HEADING')), 1))
}